<template>
	<div style=" cursor: pointer;">
		
		<transition name="fade" @after-leave="afterLeave">
			<div v-show="isShowRight" class="siderBar " style="display: flex;align-items: center;top:calc(50vh - 280px);" :class="isfirefox()? 'right12r' : ''">

				<el-card
					style="height:32px;background-color: #fff;border-radius: 20px 0 0 20px;width: 15px;line-height: 32px;">
					<i @click="disRight" style="color: #1249AC;" class="el-icon-caret-right"></i>
				</el-card>


				<el-card>
					<div style="display: flex;flex-direction: row;">

						<div style="display: flex;flex-direction: column;">
							<div v-for="(item,index) in dataArr" @click="gotoLink(item)" style="height: 80px;">
								<div style="padding: 15px;">
									<el-image style="width: 30px;height: 30px;" fit="contain"
										:src="item.icon"></el-image>
									<div style="color:#000;font-size: 11px;">{{item.title}}</div>
								</div>

								<div v-if="index < dataArr.length - 1"
									style="height: 0.0625rem;width: 100%;background-color: #ccc;"></div>
							</div>
						</div>
					</div>




				</el-card>

			</div>
		</transition>

		<el-card class="siderBar" v-show="showOtherArrow"
			style=" top:calc(50vh - 16px);height:32px;line-height:32px;background-color: #1249AC;border-radius: 20px 0 0 20px;width: 15px;" :class="isfirefox() ? 'right12r' : ''">
			<i @click="showRight" style="color: #fff;" class="el-icon-caret-left"></i>
		</el-card>
	</div>

</template>

<script>
	export default {
		name: 'sider',
		components: {

		},
		data() {
			return {
				isLogin: false,
				showOtherArrow: false,
				isShowRight: true,
				dataArr: [{
						link: "/login",
						icon: require("../assets/images/sider_denglu.png"),
						title: "登录"
					},
					{
						link: '/myCaseList',
						icon: require("../assets/images/sider_anjian.png"),
						title: "我的案件"
					},
					{
						link: '/myComment',
						icon: require("../assets/images/sider_pingjia.png"),
						title: "我的评价"
					},
					{
						link: '/myAttention',
						icon: require("../assets/images/sider_guanzhu.png"),
						title: "我的关注"
					},
					{
						link: '/myCollection',
						icon: require("../assets/images/sider_shoucang.png"),
						title: "我的收藏"
					},
					{
						link: '/reportComplaints',
						icon: require("../assets/images/sider_tousu.png"),
						title: "我的投诉"
					},
					{
						icon: require("../assets/images/sider_top.png"),
						title: "回到顶部"
					}
				]
			}

		},
		created() {
			this.isLogin = localStorage.getItem('loginToken') ? true : false
			if (this.isLogin) {
				this.dataArr[0].title = '退出登录'
			}
		},
		methods: {
			isfirefox () {
			    return (/firefox/i).test(navigator.userAgent);
			},
			gotoLink(item) {
				console.log("item", item)
				if (item.title == '退出登录') {
					localStorage.removeItem('loginToken')
					this.$router.replace('/login')
				} else if (item.title == '回到顶部') {
					console.log(11)
					this.scrollToTop()
					document.getElementById("nav-bar").style.display = "block";
				} else {
					if (!this.isLogin) {
						this.$router.replace('/login')
					} else {
						this.$router.push(item.link)
					}

				}
			},
			scrollToTop() {
				$("html,body").animate({
					scrollTop: 0
				}, 1);
				// window.scrollTo({
				// 	top: 0,
				// 	behavior: 'smooth'
				// });
				this.$emit("scrollToTop")
				// window.scrollTo(0, 0);
			},
			afterLeave() {
				this.showOtherArrow = true
			},
			showRight() {
				this.isShowRight = true
				this.showOtherArrow = false
			},
			disRight() {
				this.isShowRight = false
				console.log('????')
			}
		}
	}
</script>

<style>
	.right12r{
		right: 12px !important;
	}
	.siderBar {
		position: fixed;
		/* top: 0; */
		/* bottom: 0; */
		right: 0;
		/* width: 250px; */


		/* 平滑过渡效果 */
		 z-index: 9999;


	}

	/*设置动画*/
	.fade-enter,
	.fade-leave-to {
		transform: translateX(80%);
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: 0.6s;
	}

	.fade-enter-to {
		transform: translateX(0)
	}
</style>


// WEBPACK FOOTER //
// src/components/rightSidebar.vue